/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookOpenIcon24Solid = forwardRef('BookOpenIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M11.125 4.74c-2.73-2.002-6.69-1.849-8.755-1.593-.809.1-1.37.804-1.37 1.619v12.987c0 1.067.948 1.902 2.014 1.887 2.043-.028 5.219.232 7.476 1.848.191.136.406.242.635.317V4.74Z" }),
        React.createElement("path", { d: "M12.875 21.805a2.35 2.35 0 0 0 .635-.317c2.258-1.616 5.433-1.876 7.476-1.848 1.066.015 2.014-.82 2.014-1.887V4.766c0-.815-.561-1.518-1.37-1.619-2.065-.256-6.026-.409-8.755 1.593v17.065Z" })));
});
